// frontend/src/components/MlExperiment/MlExperimentSummary.tsx

import React from 'react';

interface Props {
  summary: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const MlExperimentSummary: React.FC<Props> = ({ summary }) => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #1a4a7a',
      marginBottom: '24px'
    }}>
      <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>
        📊 Resumo dos Experimentos
      </h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#8899aa' }}>Total</div>
          <div style={{ fontSize: '24px', color: '#4fc3f7' }}>{renderValue(summary.total_experiments)}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#8899aa' }}>✅ Aprovados</div>
          <div style={{ fontSize: '24px', color: '#66bb6a' }}>{renderValue(summary.approved)}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#8899aa' }}>❌ Rejeitados</div>
          <div style={{ fontSize: '24px', color: '#ef5350' }}>{renderValue(summary.rejected)}</div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#8899aa' }}>📈 Taxa Aprovação</div>
          <div style={{ fontSize: '24px', color: '#4fc3f7' }}>
            {renderValue(summary.approval_rate)}
          </div>
        </div>
      </div>
      <div style={{
        marginTop: '16px',
        paddingTop: '16px',
        borderTop: '1px solid rgba(26, 74, 122, 0.3)',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '12px'
      }}>
        <div>
          <div style={{ fontSize: '12px', color: '#8899aa' }}>🏆 Melhor Modelo</div>
          <div style={{ fontSize: '14px', color: '#66bb6a' }}>
            {summary.best_metric ? renderValue(summary.best_metric.strategy_name) : '—'}
          </div>
          {summary.best_metric && (
            <div style={{ fontSize: '12px', color: '#8899aa' }}>
              {renderValue(summary.best_metric.metric_name)}: {renderValue(summary.best_metric.value)}
            </div>
          )}
        </div>
        <div>
          <div style={{ fontSize: '12px', color: '#8899aa' }}>🧪 Estratégias Testadas</div>
          <div style={{ fontSize: '14px', color: '#ffffff' }}>
            {renderValue(summary.strategies_tested)}
          </div>
        </div>
      </div>
    </div>
  );
};